import { TipoProductos } from '@/interface/producto.model';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralService } from '@services/general.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-new-producto',
  templateUrl: './new-producto.component.html',
  styleUrls: ['./new-producto.component.scss']
})
export class NewProductoComponent {
  tipoProductos: TipoProductos;
  @Input() isCollapsed: boolean = true;
  @Input() showButton: boolean = true;
  productoForm: FormGroup;
  @Output() updateData = new EventEmitter();

  constructor(
    public generalService: GeneralService,
    private fb: FormBuilder,
    private toastr: ToastrService,
  ) {
  }

  async ngOnInit() {
    await this.getData();
    this.initializeForm();
  }

  initializeForm() {
    this.productoForm = this.fb.group({
      tipo_producto: [null, Validators.required],
      nombre: [null, Validators.required],
      procesamiento: [null, Validators.required],
      valor: [null, Validators.required],
      costo: [null, Validators.required],
      useStock: [null, Validators.required],
      stock: [null],
    });
  }

  onlyNumber(e: any) {
    const regExp = /[^0-9]+/g;
    e.target.value = e.target.value.replace(regExp, '');
  }

  async getData() {
    try {
      let res = await this.generalService.getListar("tipo_producto")
      this.tipoProductos = res.data;
    } catch (error) {
      console.log(error)
    }
  }

  async GuardaProducto(form: any) {
    try {
      let payload = {
        nombre: form.nombre,
        valor: form.valor,
        costo: form.costo,
        id_tipoproducto: form.tipo_producto,
        procesamiento: form.procesamiento,
        useStock: form.useStock,
        stock: form.useStock == false ? 0 : form.stock
      }
      await this.generalService.postCrear("producto", payload)
      this.toastr.success('Producto creado correctamente!');
      this.updateData.emit();
      this.productoForm.get('tipo_producto').setValue(null)
      this.productoForm.get('nombre').setValue(null)
      this.productoForm.get('procesamiento').setValue(null)
      this.productoForm.get('valor').setValue(null)
      this.productoForm.get('costo').setValue(null)
      this.productoForm.get('useStock').setValue(false)
      this.productoForm.get('stock').setValue(null)
      this.isCollapsed = !this.isCollapsed;
    } catch (error) {
      this.toastr.error('Error al crear!')
    }
  }
}
